function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgTradeOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.5a.5.5 0 0 1 .5-.5h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1-.5-.5ZM1 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1-.5-.5Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.658 2.026a.5.5 0 0 1 .316.632l-2 6a.5.5 0 0 1-.948-.316l2-6a.5.5 0 0 1 .632-.316ZM12.658 2.026a.5.5 0 0 1 .317.632l-2 6a.5.5 0 0 1-.95-.316l2-6a.5.5 0 0 1 .633-.316Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM10 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.342 2.026a.5.5 0 0 1 .632.316l2 6a.5.5 0 0 1-.948.316l-2-6a.5.5 0 0 1 .316-.632ZM12.342 2.026a.5.5 0 0 1 .633.316l2 6a.5.5 0 0 1-.95.316l-2-6a.5.5 0 0 1 .317-.632ZM8 1a.5.5 0 0 1 .5.5V14a.5.5 0 0 1-1 0V1.5A.5.5 0 0 1 8 1Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a.5.5 0 0 1 .5.5c0 .63.204.978.445 1.178.257.215.63.322 1.055.322.426 0 .798-.107 1.055-.322C4.796 9.478 5 9.13 5 8.5a.5.5 0 1 1 1 0c0 .87-.296 1.523-.805 1.947-.493.41-1.12.553-1.695.553-.574 0-1.202-.143-1.695-.553C1.296 10.023 1 9.37 1 8.5a.5.5 0 0 1 .5-.5ZM10.5 8a.5.5 0 0 1 .5.5c0 .63.204.978.445 1.178.257.215.63.322 1.055.322.426 0 .798-.107 1.055-.322.241-.2.445-.548.445-1.178a.5.5 0 0 1 1 0c0 .87-.296 1.523-.805 1.947-.493.41-1.12.553-1.695.553-.574 0-1.202-.143-1.695-.553C10.296 10.023 10 9.37 10 8.5a.5.5 0 0 1 .5-.5Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgTradeOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgTradeOutlinedIcon);
export default Memo;